export const ArticleTypes = {
  BEGINNER: 'BEGINNER',
  ADVANCED: 'ADVANCED'
} as const;

export const MAX_CONTENT_WIDTH_SM = 1200;
